import { useState } from "react";
import { API_FETCH_STATUS } from "constants/common";
import { fetchFooterData } from "components/ABfooter/services/ABfooter.services";
const {SUCCESS,LOADING,ERROR} = API_FETCH_STATUS;

const useFetchFooter = () => {
  const [response, setResponse] = useState({ status: LOADING, content: null });
  const { status, content } = response;

  const fetchFooter = () => {
    setResponse({ ...response, status: LOADING });
    return fetchFooterData()
      .then((response) => {
          setResponse({ status: SUCCESS, content: response });
      })
      .catch((error) => {
        setResponse({ status: ERROR, content: error });
      });
  };

  return { fetchFooter, status, content };
};

export default useFetchFooter;
